import React, {useMemo} from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';

const Default = () => {

    return <>
        <Box className="mtska-chart-wrapper">
            <KPI
                title="Sources"
                icon="faGauge"
                dataProviderName={'statistics/item/count/advertisings/source'}
            />
        </Box>
        <List />
    </>

}

export default Default;


